import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class UserGroupService extends BaseService {
    entityName = 'UserGroup';
    serviceCode = 'Authorization';

    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
                this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    getDetailCustom(id: string, pid: string) {
        const url = `${this.serviceUri}/GetDetailCustom/${id}?pid=${pid}`;
        return this.defaultGet(url);
    }

    updateUserGroupForUser(idUser: string, lstIdGroup: string[]) {
        return this.defaultPost(`${this.serviceUri}/UpdateUserGroupForUser`, {
            guidValue: idUser,
            listGuidValue: lstIdGroup
        });
    }
}
